import { render } from "./ProductOrders.vue?vue&type=template&id=54380108&scoped=true"
import script from "./ProductOrders.vue?vue&type=script&lang=js"
export * from "./ProductOrders.vue?vue&type=script&lang=js"

import "./ProductOrders.vue?vue&type=style&index=0&id=54380108&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54380108"]])

export default __exports__